import { ENV_CONFIG } from './env';

// API Configuration
export const API_CONFIG = {
  BASE_URL: ENV_CONFIG.API_BASE_URL,
  ENDPOINTS: {
    PROGRAMS: '/programs',
    PROGRAMS_BY_SLUG: '/programs/slug',
    FEATURED_PROGRAMS: '/programs/featured',
    CATEGORIES: '/categories',
    PROGRAM_UPDATES: '/program-updates',
    PROGRAM_UPDATES_TIMELINE: '/program-updates/timeline',
    PAYMENT_METHODS: '/payment-methods',
  },
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
} as const;

// API Response Types
export interface ApiResponse<T> {
  status: 'success' | 'error';
  data: T;
  meta?: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
    hasNext?: boolean;
    hasPrev?: boolean;
    [key: string]: any;
  };
  error: string | null;
}

// Pagination Types
export interface PaginationParams {
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: string;
  /** Lifecycle scope for program listing: 'active' | 'finished' | 'all' */
  view?: string;
}

// Error Types
export class ApiError extends Error {
  constructor(
    message: string,
    public status?: number,
    public code?: string
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
